import { render } from "./ChatbotHomePage.vue?vue&type=template&id=2cec7bf2&scoped=true"
import script from "./ChatbotHomePage.vue?vue&type=script&lang=js"
export * from "./ChatbotHomePage.vue?vue&type=script&lang=js"

import "./ChatbotHomePage.vue?vue&type=style&index=0&id=2cec7bf2&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cec7bf2"]])

export default __exports__